import type { IconSvgObject } from './types';

const ColorPickerIcon: IconSvgObject = [
  ["path", { d: "M13.5 3.5L15 5M20.5 10.5L19 9M15 5L16.0858 3.91421C16.8668 3.13317 18.1332 3.13316 18.9142 3.91421L20.0858 5.08579C20.8668 5.86683 20.8668 7.13317 20.0858 7.91421L19 9M15 5L19 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 7L3.08579 16.9142C2.71071 17.2893 2.5 17.798 2.5 18.3284V21.5H5.67157C6.20201 21.5 6.71071 21.2893 7.08579 20.9142L17 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.5 13.5H14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ColorPickerIcon;
